// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_3y8qm4gHo7LR9NX8P_jj0","tab":"peb4fBtW9RMH56kuqQ87_","activetab":"DlJfHG7ZeTaNFMLBrf2DP"};